const defaults = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  withSymbol: true
};

const currency = (value = 0, options) => {
  const opts = {
    ...defaults,
    ...options
  };

  return `${opts.withSymbol ? '$' : ''}${Number(
    Math.abs(value) || 0
  ).toLocaleString(undefined, opts)}`;
};

export default currency;
